module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_surahammar-9ed7b4cd3667048e35baf1e2e9ab957f.png";